import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { vibeKeys } from 'helpers/events/vibe/constants'
import { vibeEventEmitter } from 'helpers/events/vibe/emitter'
import { _roomUserId } from 'store/selectors/Room'
import { isMobileOrIPad } from 'utils/device'

import VibeBtn from './VibeBtn'
import VibeNeonRing from './VibeNeonRing'
import Vibing from './Vibing'

const VIBE_TIMEOUT = 2200 // ms
const clearVibes = cb => setTimeout(cb, VIBE_TIMEOUT)

const BASE_INTENSITY = 1
const INTENSITY_STEP = 0.03
const MAX_INTENSITY = 1.5
const getIntensity = currentIntensity => {
    if (!currentIntensity) return BASE_INTENSITY
    const intensity = currentIntensity + INTENSITY_STEP
    return Math.min(intensity, MAX_INTENSITY)
}

const LetsVibe = props => {
    const { isLocal, uuid, alternate = null } = props
    const localUserId = useSelector(_roomUserId)
    const [vibingIntensity, setVibingIntensity] = useState(0)
    const [hideBtn, setHideBtn] = useState(false)
    const [showRing, setShowRing] = useState(false)
    const [showVibing, setShowVibing] = useState(false)

    useEffect(() => {
        const handleVibes = vibe => {
            const { sender, reciever } = vibe

            setShowRing(showRing =>
                showRing ? showRing : sender === uuid && !isLocal
            )
            setShowVibing(showVibing => {
                const shouldVibe = showVibing ? showVibing : reciever === uuid

                if (shouldVibe) {
                    setVibingIntensity(intensity => getIntensity(intensity))

                    setHideBtn(() => sender === localUserId)
                }

                return shouldVibe
            })
        }

        vibeEventEmitter.addListener(vibeKeys.VIBE, handleVibes)

        return () => vibeEventEmitter.removeListener(vibeKeys.VIBE, handleVibes)
    }, [localUserId, uuid])

    useEffect(() => {
        showRing && clearVibes(() => setShowRing(false))
    }, [showRing])

    useEffect(() => {
        showVibing &&
            clearVibes(() => {
                setShowVibing(false)
                setHideBtn(false)
                setVibingIntensity(() => 0)
            })
    }, [showVibing])

    const vibingProps = {
        ...props,
        vibingIntensity,
    }

    const btnProps = {
        ...props,
        localUserId,
        disabled: hideBtn,
    }

    if (isMobileOrIPad) return null

    return (
        <>
            {!isLocal && <VibeBtn {...btnProps} />}
            {showRing && <VibeNeonRing {...props} />}
            {showVibing ? <Vibing {...vibingProps} /> : alternate}
        </>
    )
}

export default LetsVibe
